import * as types from "containers/starshop/ActionType";

const initialState = {
	starPoint: "",
	productList: [],
	pointUseList: [],
	pointSaveList: [],
	goalsRequset: "",
	changedTarget: [],
	deleteState: "",
	passTargetArr: [],
	setGoalState: "",
	exchangeCode: "",
	exchangeHistroy: "",
	profilePhoto: "",
	mmbrType: "",
	schoolStatus: null,
};

export default function starshopReducer(state = initialState, action) {
	switch (action.type) {
		case types.STAR_POINT_SUCCESS:
			return {
				...state,
				starPoint: action.payload.STAR_POINT.SUMMARY,
			};
		case types.STAR_POINT_FAILURE:
			return {
				...state,
			};
		case types.PRODUCT_LIST_SUCCESS:
			return {
				...state,
				productList: action.payload,
			};
		case types.PRODUCT_LIST_FAILURE:
			return {
				...state,
			};
		case types.POINT_USELIST_SUCCESS:
			return {
				...state,
				pointUseList: action.payload,
			};
		case types.POINT_USELIST_FAILURE:
			return {
				...state,
			};
		case types.POINT_SAVELIST_SUCCESS:
			return {
				...state,
				pointSaveList: action.payload,
			};
		case types.POINT_SAVELIST_FAILURE:
			return {
				...state,
			};
		case types.SET_GOALS_SUCCESS:
			return {
				...state,
				setGoalState: action.payload,
			};
		case types.SET_GOALS_FAILURE:
			return {
				...state,
			};
		case types.GET_GOALS_SUCCESS:
			return {
				...state,
				targetInfo: action.payload,
			};
		case types.GET_GOALS_FAILURE:
			return {
				...state,
			};
		case types.DELETE_TARGET_SUCCESS:
			return {
				...state,
				deleteState: action.payload,
			};
		case types.DELETE_TARGET_FAILURE:
			return {
				...state,
			};
		case types.PASS_TARGET_ARRAY:
			return {
				...state,
				passTargetArr: action.payload.targetInfo,
			};
		case types.EXCHANGE_PRODUCT_SUCCESS:
			return {
				...state,
				exchangeCode: action.payload.responseCode,
			};
		case types.EXCHANGE_PRODUCT_FAILURE:
			return {
				...state,
			};
		case types.EXCHANGE_HISTORY_SUCCESS:
			return {
				...state,
				//exchangeHistroy : action.payload ,
				exchangeHistroy: action.payload,
			};
		case types.EXCHANGE_HISTORY_FAILURE:
			return {
				...state,
			};
		case types.PROFILE_PHOTO_SUCCESS:
			return {
				...state,
				profilePhoto: action.payload.MMBR_PHTG_INFO.FILE_INFO,
			};
		case types.EXCHANGE_HISTORY_FAILURE:
			return {
				...state,
			};
		case types.MMBR_TYPE_SUCCESS:
			return {
				...state,
				mmbrType: action.payload.MMBR_TYPE,
				schoolStatus: action.payload.SCHOOL,
			};
		case types.MMBR_TYPE_FAILURE:
			return {
				...state,
			};
		default:
			return state;
	}
}
